module.exports = __webpack_public_path__ + "static/media/tache.6c824138.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/MarkCall/tache.svg
// module id = 1809
// module chunks = 0